import { DialogEnums } from "models/enums";
import { BankIdSignDialogContentType, DialogProps } from "models/propTypes/dialogPropTypes";

function useBankIdSignDialog(
  properties: BankIdSignDialogContentType,
  onSubmit?: (values?: any) => void,
  onError?: (values?: any, closeDialog?: () => void) => void
): DialogProps {
  return {
    isOpen: false,
    title: "",
    subTitle: "",
    dialogType: DialogEnums.DialogType.BankIdSign,
    children: properties,
    onSubmit: onSubmit,
    onError: onError,
  };
}

export default useBankIdSignDialog;
